import script from "./ButtonShow.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonShow.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__